import gql from 'graphql-tag';

export default gql`
  fragment hubspotDealPropertyDefinitionEnumSelectOptionFragment on HubspotDealPropertyDefinitionEnumSelectOption {
    id
    displayOrder
    hidden
    label
    value
  }
`;
